<template>
  <main-layout>
    <b-loading :is-full-page="true" :active.sync="loading" />
    <div v-if="!loading">
      <h1 class="title">Modifica {{ contractType.code }}</h1>
      <contract-type-form :item="contractType" :fields="fields" />
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"
import store from "@/store"

import ContractTypeForm from "@/components/ContractTypeForm.vue"
import MainLayout from "@/layouts/Main.vue"
import { fields } from "./fields"

export default {
  components: {
    ContractTypeForm,
    MainLayout
  },
  data() {
    return {
      fields,
      loading: true
    }
  },
  computed: {
    contractType: get("contractTypes/contractType")
  },
  async beforeRouteUpdate(to, from, next) {
    this.loading = true
    await this.fetchProduct(to.params.id)
    this.loading = false
    next()
  },
  beforeDestroy() {
    store.set("contractTypes/contractType", {})
  },
  async mounted() {
    this.loading = true
    await this.fetchProduct(this.$route.params.id)
    this.loading = false
  },
  methods: {
    fetchProduct: call("contractTypes/find")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
